import { FC } from 'react';
import {
  AlertMessage,
  IconStyle,
  TextLink,
  TextLinkIconPosition,
  TextLinkStyle,
  Theme,
  useTranslation,
} from '@nextgen-web-framework/all';
import { AddNewAddress } from '@commerce-profile-webcomponents/ui';
import { IconName } from '@fortawesome/fontawesome-svg-core';
import { ICheckoutAddNewAddressProps } from '../types/propTypes';
import { ShippingTypeEnums } from '../../common/config/checkoutConstants';
import styles from './CheckoutAddNewAddress.module.scss';

export const CheckoutAddNewAddress: FC<ICheckoutAddNewAddressProps> = ({
  newAddressType,
  softFilters,
  addNewAddressCallback,
  isLoading,
  ownerId,
  addNewDeliveryAddressCtaHandler,
  isCustomView,
  heading,
  ctaText = '',
}: ICheckoutAddNewAddressProps) => {
  const t = useTranslation();

  const getCardButton = (iconName: IconName, text: string, onClickCb: () => void) => (
    <div className={styles['checkout-add-new-address-pickup-section']}>
      <TextLink
        leftIcon={{
          iconName: iconName,
          iconStyle: IconStyle.SOLID,
        }}
        iconPosition={TextLinkIconPosition.LEFT}
        id="TextLink_id"
        text={text}
        textLinkStyle={TextLinkStyle.ICONUNDERLINE}
        customClass={styles['checkout-add-new-address-pickup-cta']}
        onClick={() => onClickCb()}
        scroll={false}
      />
    </div>
  );

  return (
    <div
      className={`${styles['checkout-add-new-address-container']} ${
        isCustomView && styles['checkout-add-new-address-container-custom-view']
      }`}
    >
      <h4 className={styles['checkout-add-new-address-title']}>
        {newAddressType == ShippingTypeEnums.DELIVERY
          ? t('checkout.CheckoutAddNewAddress.titleTypeDelivery')
          : newAddressType == ShippingTypeEnums.PICKUP
            ? t('checkout.CheckoutAddNewAddress.titleTypePickup')
            : heading}
      </h4>
      {((newAddressType == ShippingTypeEnums.DELIVERY && softFilters?.delivery?.isVisible) ||
        (newAddressType == ShippingTypeEnums.PICKUP && softFilters?.pickup?.isVisible)) && (
        <AlertMessage
          icon="exclamation-triangle"
          theme={Theme.WARNING}
          iconStyle={IconStyle.REGULAR}
          className={styles['checkout-add-new-address-alert-msg']}
        >
          {newAddressType == ShippingTypeEnums.DELIVERY
            ? t(softFilters?.delivery?.message)
            : t(softFilters?.pickup?.message)}
        </AlertMessage>
      )}

      {newAddressType == ShippingTypeEnums.DELIVERY && !softFilters?.delivery?.isVisible && (
        <AddNewAddress
          useAddressLookup={false}
          onConfirmClick={addNewAddressCallback}
          isLoading={isLoading}
          ownerId={ownerId}
          onAddNewButtonClick={addNewDeliveryAddressCtaHandler}
          addNewButtonText={t('checkout.CheckoutAddNewAddress.deliveryAddressCta')}
        />
      )}
      {newAddressType == ShippingTypeEnums.PICKUP &&
        !softFilters?.pickup?.isVisible &&
        getCardButton('plus', t('checkout.CheckoutAddNewAddress.pickupCta'), addNewAddressCallback)}
      {isCustomView && getCardButton('plus', ctaText, addNewAddressCallback)}
    </div>
  );
};

export default CheckoutAddNewAddress;
